import '@babel/polyfill';

import UIGS from '@tencent/search-uigs';
import axios from 'axios';
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

import { createApp } from './entry-base';

require('es6-promise').polyfill();

Vue.use(VueLazyload, {
  preLoad: 1.7,
  attempt: 1,
  listenEvents: ['click', 'scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend'],
});

Vue.prototype.$http = axios.create();
Vue.prototype.$uigs = new UIGS({ uigs_productid: 'wap_video' });
Vue.prototype.$uigsKd = new UIGS({ uigs_productid: 'wap_video_kd' });

const { NODE_ENV } = process.env;
const isDev = NODE_ENV === 'development';
// const isProd = NODE_ENV === 'production';
if (isDev) {
  Vue.config.devtools = true;
}
// else if (isProd && window.aegis && window.aegis.error) {
//   Vue.config.errorHandler = function (err, vm, info) {
//     const { uuid = '' } = window.UIGS_PARA || {};
//     const uuidStr = uuid ? `\nuuid: ${uuid}` : '';
//     window.aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}${uuidStr}`);
//   };
// }

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
  beforeRouteUpdate(to, from, next) {
    const { asyncData } = this.$options;
    const context = {
      origin: window.location.origin,
    };
    if (asyncData) {
      asyncData({
        context,
        store: this.$store,
        route: to,
      })
        .then(next)
        .catch(next);
    } else {
      next();
    }
  },
});

const { app, router, store } = createApp();

// HACK: 增加快照判断参数，处理抓取页面快照重定向问题
const isSnapshot = window.location.pathname.indexOf('hc_video_tab_') > -1;

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
  isSnapshot && delete window.__INITIAL_STATE__.route;
  store.replaceState(window.__INITIAL_STATE__);
}

// wait until router has resolved all async before hooks
// and async components...
router.onReady(() => {
  // Add router hook for handling asyncData.
  // Doing it after initial route is resolved so that we don't double-fetch
  // the data that we already have. Using router.beforeResolve() so that all
  // async components are resolved.
  router.beforeResolve((to, from, next) => {
    if (to.query.isclient === 1) {
      return next();
    }
    const matched = router.getMatchedComponents(to);
    const prevMatched = router.getMatchedComponents(from);
    let diffed = false;
    const activated = matched.filter((c, i) => diffed || (diffed = prevMatched[i] !== c));
    const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _);
    if (!asyncDataHooks.length) {
      return next();
    }

    // bar.start();
    // 对所有匹配的路由组件调用 `asyncData()`
    const context = {
      origin: window.location.origin,
    };
    Promise.all(asyncDataHooks.map(hook => hook({ context, store, route: to })))
      .then(() => {
        // bar.finish();
        next();
      })
      .catch(next);
  });

  // actually mount to DOM
  app.$mount('#videoApp');
});
